import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_HOLIDAYS](state, data) {
    state.allHolidays = data
  },
}
